import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCategories, addItem, removeItem, } from '../../store/slices/cartSlice';
import { FaMinus, FaPlus } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { WR } from '../ui/tokens';

// VISUAL RELOOKING ONLY — same selectedItems / total data and the same
// addItem/removeItem dispatches as before.
const YourItems = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const selectedItems = useSelector(state => state.cart.selectedItems);
  const categoryItems = useSelector(state => state.cart.categoryItems);
  const catalogueEmpty = useSelector(state => state.cart.catalogueEmpty);
  const total = useSelector(state => state.cart.totalAmount);
  const totalNumber = parseFloat(total);
  const formattedTotal = totalNumber.toFixed(2);
  const lang = localStorage.getItem("lang");

  useEffect(() => {
    // An empty list that the backend confirmed (catalogueEmpty) is a state,
    // not a missing fetch — refetching it would loop on the 404.
    if (catalogueEmpty) return;
    if (!categoryItems || categoryItems.length === 0) {
      dispatch(fetchCategories());
    }
  }, [dispatch, categoryItems, catalogueEmpty]);

  const handleAddItem = (itemId) => {
    dispatch(addItem(itemId));
  };

  const handleRemoveItem = (itemId) => {
    dispatch(removeItem(itemId));
  };

  const miniBtn = (variant) => ({
    width: 26,
    height: 26,
    borderRadius: WR.radius.pill,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 0,
    cursor: 'pointer',
    flexShrink: 0,
    background: variant === 'inc' ? WR.color.brand : WR.color.lavSoft,
    color: variant === 'inc' ? '#fff' : WR.color.brand,
  });

  return (
    <div
      style={{
        background: WR.color.surface,
        borderRadius: WR.radius.lg,
        boxShadow: WR.shadow.card,
        padding: WR.space.xl,
        fontFamily: WR.font.sans,
      }}
    >
      <div
        style={{
          fontSize: WR.text.eyebrow,
          fontWeight: WR.weight.extra,
          letterSpacing: 1.5,
          textTransform: 'uppercase',
          color: WR.color.inkSoft,
          marginBottom: WR.space.lg,
        }}
      >
        {t("YOUR_ITEMS")}
      </div>

      {selectedItems?.length === 0 ? (
        <div
          style={{
            padding: '18px 0 4px',
            textAlign: 'center',
            fontSize: WR.text.small,
            color: WR.color.inkMuted,
          }}
        >
          {t("NO_ITEMS_IN_CART")}
        </div>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {selectedItems?.map(selectedItem => (
            <li
              key={selectedItem.id}
              style={{ padding: '12px 0', borderTop: `1px solid ${WR.color.hairline}` }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 10,
                }}
              >
                <span style={{ fontSize: WR.text.body, fontWeight: WR.weight.bold, color: WR.color.encre }}>
                  {lang === 'french' ? selectedItem?.name_fr : lang === 'dutch' ? selectedItem?.name_nl : selectedItem?.name}
                </span>
                <span style={{ fontSize: WR.text.body, fontWeight: WR.weight.extra, color: WR.color.encre, whiteSpace: 'nowrap' }}>
                  {selectedItem?.price}{' '}€
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                <button style={miniBtn('dec')} onClick={() => handleRemoveItem(selectedItem.id)}>
                  <FaMinus size={12} />
                </button>
                <span style={{ minWidth: 16, textAlign: 'center', fontSize: WR.text.small, fontWeight: WR.weight.extra, color: WR.color.encre }}>
                  {selectedItem.quantity}
                </span>
                <button style={miniBtn('inc')} onClick={() => handleAddItem(selectedItem.id)}>
                  <FaPlus size={12} />
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginTop: WR.space.lg,
          paddingTop: WR.space.lg,
          borderTop: `1.5px solid ${WR.color.hairline}`,
        }}
      >
        <span style={{ fontSize: WR.text.slot, fontWeight: WR.weight.bold, color: WR.color.inkMuted }}>{t("TOTAL")}</span>
        <span style={{ fontSize: WR.text.h2, fontWeight: WR.weight.extra, color: WR.color.brand }}>{formattedTotal}€</span>
      </div>
    </div>
  );
}

export default YourItems;
